import { FC, useMemo } from 'react';
import RightArrow from 'icon/chevron_right_fill.svg';
import { ClickPosition } from '~/utils/click-position';
import { useActiveToSearch } from '~/utils/active/use-active-to-search';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import useReflowClick from '~/utils/use-reflow-click';
import { $CurrentDiscoverKeyword } from '~/routes/discover.$keyword/shared/atom';
import { kepQueryFormat } from 'shared/utils/format/kep-formatter';

interface IBreadcrumbItemProps {
  isLast: boolean;
  query: string;
  index: number;
}

const BreadcrumbsItem: FC<IBreadcrumbItemProps> = ({ isLast, query, index }) => {
  const keyword = useAtomValue($CurrentDiscoverKeyword);
  const { region } = useAtomValue($Locale);
  const activeToSearch = useActiveToSearch(query);

  const href = useMemo(() => `/discover/${kepQueryFormat(query)}?region=${region}`, [query]);

  const handleQueryClick = useReflowClick(
    {
      reflowBehavior: () => {
        activeToSearch(ClickPosition.kep_breadcrumbs);
      },
      clickEvent: () => ({
        page_id: keyword,
        current_position: ClickPosition.kep_breadcrumbs,
        page_click_id: kepQueryFormat(query),
      }),
    },
    [activeToSearch],
  );

  return isLast ? (
    <li key={`kep-nav-active-${index}`} className="nav-active">
      <div className="nav-active-link">
        <a href={href} onClick={handleQueryClick}>
          {query}
        </a>
      </div>
    </li>
  ) : (
    <li key={`kep-nav-item-${index}`} className="nav-item">
      <div className="nav-item-link">
        <a href={href} onClick={handleQueryClick}>
          {query}
        </a>
      </div>
      <div className="nav-arrow">
        <div className="nav-arrow-wrapper">
          <RightArrow />
        </div>
      </div>
    </li>
  );
};

export default BreadcrumbsItem;
